import React from "react";

export const MapContext = React.createContext({
    map: null,
    mapCenter: null,
    mapId:""
});

export const withMapContext = (Component) => {
  return (props) =>{
    return (
      <MapContext.Consumer>
        { mapProps => <Component {...props} {...mapProps} />}
      </MapContext.Consumer>
    );
  };
}
